<template>
  <div class="container">
    <div v-for="(item, index) in adDetails" :key="index">
      <p>第{{ index + 1 }}份广告</p>
      <div class="first-part">
        <van-cell
          v-if="index === 0"
          title="门店类型"
          :value="item.dealerType === 1 ? '汽修厂' : '专卖店'"
        />
        <van-cell
          v-if="index === 0"
          title="品牌类型"
          :value="apply.productBrand | productBrand"
        />
        <van-cell v-if="index === 0" title="广告类型" value="门头招牌" />
        <van-cell
          title="材质"
          :value="item.materialQuality | materialQuality"
        />
        <div class="example-img">
          <div>版面示例</div>
          <van-image :src="item.pageExample" @click="previewImg">
            <template v-slot:error>加载失败</template>
          </van-image>
        </div>
      </div>
      <div class="second-part">
        <van-cell title="广告长度" :value="item.longs + '米'" />
        <van-cell title="广告长度" :value="item.height + '米'" />
        <van-cell
          title="广告内容"
          :value="item.content.trim() === '' ? '无内容' : item.content"
        />
        <van-cell
          class="scenery"
          title="实景图片"
          :value="item.realSceneImg.length === 0 ? '无上传照片' : ''"
        />
        <van-image
          v-for="(img, indexes) in item.realSceneImg"
          :key="indexes"
          width="100"
          height="100"
          fit="contain"
          :src="$imgPath + img"
          @click="previewImg"
        />
      </div>
    </div>
    <div class="third-part">
      广告预估总费用: <span class="price">{{ apply.estimateTotalCost }}</span>
    </div>
    <van-button type="primary" @click="handlerConfirm">下一步</van-button>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      apply: {},
      adDetails: [],
      adID: ""
    };
  },
  filters: {
    productBrand(type) {
      switch (type) {
        case 1:
          return "原动力";
        case 2:
          return "力猛";
        case 3:
          return "原动力+力猛";
        default:
          break;
      }
    },
    materialQuality(type) {
      switch (type) {
        case 1:
          return "铁架+灯布";
        case 2:
          return "彩钢板+PVC";
        case 3:
          return "铝塑板+PVC字";
        case 4:
          return "铝塑板+平面发光字";
        case 5:
          return "纯灯布";
        default:
          break;
      }
    }
  },
  created() {
    let adUrl = this.$route.path;
    let index = adUrl.lastIndexOf("/");
    adUrl = adUrl.substring(index + 1, adUrl.length);
    this.adID = Base64.decode(adUrl);
    this.getDetail();
  },
  methods: {
    // 广告详情
    getDetail() {
      this.$api.adDetails(this.adID).then(res => {
        // console.log("广告详情: ", res);
        res = res.result;
        this.apply = res.apply;
        this.adDetails = res.contents;
        this.adDetails.forEach(val => {
          if (val.realSceneImg.length != 0) {
            val.realSceneImg = val.realSceneImg.split(",");
          } else {
            val.realSceneImg = [];
          }
        });
      });
    },
    // 下一步
    handlerConfirm() {
      sessionStorage.setItem("adID", this.adID);
      this.$router.push("/shop/deal");
    },
    //预览图片
    previewImg(e) {
      ImagePreview([e.srcElement.src]);
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding-bottom: 20px;

  .first-part {
    border-bottom: 15px solid #eaeaea;

    .example-img {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      font-size: 14px;

      div {
        flex: 1;
        text-align: left;
      }

      van-image {
        flex: 1;
      }
    }

    .van-cell__title {
      text-align: left;
    }

    .van-cell__value {
      text-align: center;
    }
  }

  .second-part {
    border-bottom: 15px solid #eaeaea;
    margin-bottom: 20px;

    .van-cell__title {
      text-align: left;
    }

    .van-cell__value {
      text-align: center;
    }
  }

  .third-part {
    margin-bottom: 20px;

    .price {
      color: red;
    }
  }
}
</style>
<style lang="scss">
.scenery:not(:last-child)::after {
  display: none;
}
</style>
